import axios from 'axios';
import { useMutation } from 'react-query';
import { KA_API_URL } from '../../config/baseUrl';
import { KA_QUEUE } from '../../components/setup/IntegrationConstants';

/**
 * Requests
 */

export const createSchedule = async (datasetId, industry, dataType, description) =>
  axios.post(`${KA_API_URL}/schedule`, [
    {
      refresh_period: 'DAY',
      refresh_day: 0,
      run_at_time_gmt: '', // see API - this will get calculated (KP-4163)
      ka_queue: KA_QUEUE.PROCESS,
      description,
      message: {
        dataset_ids: datasetId,
        industry,
        data_type: dataType,
      },
    },
  ]);

/**
 * Hooks
 */

export const useCreatePartnerSchedule = mutationConfig =>
  useMutation(async ({ datasetId, industry, dataType, description }) => {
    const response = await createSchedule(datasetId, industry, dataType, description);

    return response?.data;
  }, mutationConfig);
